import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  enable() {
    this.element.disabled = false;
    this.element.parentElement.title = '';
  }
}
